import { useMemo } from 'react'
import {
  resolveBoardAccessibleUsers,
  TaskTrackerAccessibleUser,
} from '../taskTrackerBoardAccessibleUsers.utils'
import { useTaskTrackerBoardAccess } from './useTaskTrackerBoardAccess'

export const useTaskTrackerBoardAccessibleUsers = (
  boardId: number | null,
  projectId: number | null,
  enabled: boolean,
) => {
  const boardAccess = useTaskTrackerBoardAccess(boardId, projectId, enabled)
  const {
    accessLoaded,
    effectiveAccessMode,
    selectedMembers,
    projectMembers,
    accessLoading,
    accessError,
    projectMembersLoading,
    projectMembersError,
  } = boardAccess

  const users = useMemo((): TaskTrackerAccessibleUser[] => {
    if (!accessLoaded) return []

    return resolveBoardAccessibleUsers(
      effectiveAccessMode,
      selectedMembers,
      projectMembers,
    )
  }, [accessLoaded, effectiveAccessMode, projectMembers, selectedMembers])

  const loading = !accessLoaded || accessLoading || projectMembersLoading
  const error = accessError || projectMembersError

  return {
    users,
    loading,
    error,
    boardAccess,
    reload: boardAccess.reload,
  }
}
